"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTRICTED_TABS = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
exports.RESTRICTED_TABS = [
    bridge_schema_1.InfoBoxTabType.CrossSections,
    bridge_schema_1.InfoBoxTabType.BoneParts,
    bridge_schema_1.InfoBoxTabType.BoneSurfaces,
    bridge_schema_1.InfoBoxTabType.BoneLandmarks,
    bridge_schema_1.InfoBoxTabType.Sutures,
    bridge_schema_1.InfoBoxTabType.Craniometrics,
];
